import type { LocaleDictionary } from "@/i18n/types";

const nsGridJA = {
  unknownStatus: "不明なステータス",
  otherColumn: "その他",
  enabled: "有効",
  disabled: "無効",
  memberCount: ({ count, max }: { count: number; max: number }) =>
    `${count} / ${max} 名`,
  memberCountUnlimited: ({ count }: { count: number }) => `${count} / ∞ 名`,
} satisfies LocaleDictionary;

export default nsGridJA;
